var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckYogAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.96 3.35475C15.324 2.814 14.3782 2.90175 13.8472 3.55125L7.2105 11.6775L3.8325 9.3795C3.144 8.91 2.21175 9.1005 1.75275 9.804C1.29375 10.5075 1.47975 11.4577 2.169 11.9265L7.7895 15.75L16.1527 5.51025C16.683 4.86075 16.5967 3.89625 15.96 3.35475V3.35475Z",
    fill: "#5F698B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckYogAdmin);
export default __webpack_public_path__ + "static/media/icon_check_yog_admin.de6bc5d850c8f804a29a67d73d7131e7.svg";
export { ForwardRef as ReactComponent };